import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { NotificationService } from '../../services/notification.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-simple-enquiry-detail',
  templateUrl: './simple-enquiry-detail.component.html',
  styleUrl: './simple-enquiry-detail.component.scss'
})
export class SimpleEnquiryDetailComponent implements OnInit {
  noteId: string | null = null;
  isLoading: boolean = true;
  detail: any = null;
  selectedImage: string | null = null;
  
  // Audio state
  isPlayingAudio: boolean = false;
  audioElement: HTMLAudioElement | null = null;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private http: ApiService,
    private notify: NotificationService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.noteId = params['note_id'];
      if (this.noteId) {
        this.fetchDetails();
      } else {
        this.notify.showError('Invalid Enquiry ID', '');
        this.router.navigate(['/dashboard']);
      }
    });
  }

  fetchDetails() {
    this.isLoading = true;
    this.http.get(`retailers/getEnquiryNoteDetails?note_id=${this.noteId}`).subscribe(
      (res: any) => {
        this.isLoading = false;
        const responseObj = res.response ? res.response : res;
        if (responseObj && responseObj.code === 1 && responseObj.data) {
          this.detail = responseObj.data;
        } else {
          this.notify.showError('Failed to load enquiry details', '');
        }
      },
      (error) => {
        this.isLoading = false;
        this.notify.showError('Error loading details', '');
      }
    );
  }

  openImageModal(imgUrl: string) {
    this.selectedImage = imgUrl;
  }

  closeImageModal() {
    this.selectedImage = null;
  }

  playAudio(url: string) {
    if (this.audioElement && this.isPlayingAudio) {
      this.audioElement.pause();
      this.isPlayingAudio = false;
      return;
    }

    if (!this.audioElement) {
      this.audioElement = new Audio(url);
      this.audioElement.onended = () => {
        this.isPlayingAudio = false;
      };
    }
    
    this.audioElement.play().catch(e => {
      console.error('Error playing audio', e);
      this.notify.showError('Could not play audio', '');
    });
    this.isPlayingAudio = true;
  }

  ngOnDestroy() {
    if (this.audioElement) {
      this.audioElement.pause();
      this.audioElement = null;
    }
  }
}
